import React, { type ReactNode, useMemo } from 'react';

import { RelayEnvironmentProvider } from 'react-relay';
import { createMockEnvironment } from 'relay-test-utils';

export const RelayEnvironmentWrapper = ({
	children,
}: {
	children: ReactNode;
}): React.JSX.Element => {
	const env = useMemo(() => createMockEnvironment(), []);

	return <RelayEnvironmentProvider environment={env}>{children}</RelayEnvironmentProvider>;
};
